import React, { useEffect, useState } from "react";
import {
  conditionInvalidate,
  typeMoneyDescription,
} from "../../Utils/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  modalAside,
  stateAlert,
  alert as alertMessage,
} from "../../Store/simulate/actions";
import { 
  sendImprovement, 
  sendRecalculate, 
  getQuotesList, 
  updateBeneficiary, 
  updateAssured 
} from "../../Services/RVModalService";
import moment from "moment";

interface useModalSideRVProps {
  data: any;
  selectedModality: any;
  handleSucessImprovements: any;
}

export const useModalSideRV = ({
  data,
  selectedModality,
  handleSucessImprovements,
}: useModalSideRVProps) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState<any>(false);
  const [improvedData, setImprovedData] = useState<any>();
  const [recalculatedData, setRecalculatedData] = useState<any>();
  const typeMoneyDescriptionList: any = typeMoneyDescription;
  const [loadingState, setLoadingState] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showWarningUserValidation, setShowWarningUserValidation] =
    useState(false);
  const [errorDate, setErrorDate] = useState<any>();
  const [dataRecalculate, setDataRecalculate] = useState<any>();
  const [selectDate1, setSelectDate1] = useState(new Date());
  const conditionInvalidateList: any = conditionInvalidate;
  const modalAsideState = useSelector(
    (state: any) => state.simulate.policy.modalAside
  );

  const handleOpen = async () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    const modalInner = document.querySelector(".modal-aside__inner_rv");
    if (modalInner) {
      modalInner.scrollTop = 0;
    }
    setIsOpen(false);
    dispatch(modalAside(false));
    setDataRecalculate(null);
    setImprovedData(null);
    setSelectDate1(new Date());
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (modalAsideState) {
      handleOpen();
    } else {
      handleClose();
      setShowWarningUserValidation(false);
    }
  }, [modalAsideState]);

  const onSubmitImprovement = async (values: any) => {
    setLoadingState(true);
    const { cesionComision, tir } = values;
    const payload = {
      payload: {
        data: {
          producto: {
            CodProducto: "RV",
            mejora: {
              id: data.id,
              indice: selectedModality.indice,
              cuspp: data.CUSPP,
              tasaVenta: (Number(tir) / 100).toString(),
              cesionComision: (Number(cesionComision) / 100).toString(),
              guardar: false,
            },
          },
        },
      },
    };

    await sendImprovement(payload, getQuotes);
    setLoadingState(false);
    getQuotes();
  };

  const onSubmitReCalculate = async (values: any) => {
    setLoadingState(true);
    const { cic, exchangeRate } = values;
    const payload = {
      payload: {
        data: {
          producto: {
            CodProducto: "RV",
            recalculo: {
              id: data.id,
              indice: selectedModality.indice,
              cuspp: data.CUSPP,
              cic: cic,
              guardar: false,
              tipoCambio: exchangeRate || 0,
            },
          },
        },
      },
    };

    try {
      const response = await sendRecalculate(payload);
      setLoadingState(false);
      setDataRecalculate(response.payload.body);
    } catch (error) {
      setTimeout(() => {}, 25000);
      console.error(error);
    }
  };

  const saveRecalculated = async (exchangeRate: number | null) => {
    setLoadingState(true);
    const payload = {
      payload: {
        data: {
          producto: {
            CodProducto: "RV",
            recalculo: {
              fechaRecal1: selectDate1 ? moment(selectDate1).format("YYYY-MM-DD") : "",
              tipoCambio: exchangeRate || 0,
              id: data.id,
              indice: selectedModality.indice,
              cuspp: data.CUSPP,
              cic: dataRecalculate.modalidad.cic,
              guardar: true,
            },
          },
        },
      },
    };
    try {
      await sendRecalculate(payload);
      setLoadingState(false);
      setTimeout(() => {
        setAlert(
          "success",
          "Recalculo exitoso!",
          "Se ha guardado el recalculo."
        );
      }, 2000);
      handleClose();
      handleSucessImprovements();
    } catch (error) {
      getQuotes();
      console.error(error);
    }
  };

  const setAlert = (type: any, title: any, message: any) => {
    dispatch(stateAlert(true));
    dispatch(
      alertMessage({
        type,
        title,
        message,
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 4000);
  };

  const saveImprovement = async () => {
    setLoadingState(true);
    const { cesionComision, tir } = improvedData;
    const payload = {
      payload: {
        data: {
          producto: {
            CodProducto: "RV",
            mejora: {
              id: data.id,
              indice: selectedModality.indice,
              cuspp: data.CUSPP,
              tasaVenta: tir,
              cesionComision: cesionComision,
              guardar: true,
            },
          },
        },
      },
    };

    try {
      await sendImprovement(payload, async () => {});
      setTimeout(() => {
        setAlert(
          "success",
          "Mejora exitosa!",
          "Se ha realizado la mejora."
        );
      }, 2000);
      handleClose();
      handleSucessImprovements();
      setLoadingState(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getQuotes = async () => {
    const req: string = localStorage.getItem("REQUEST_RV") || "";
    const params = JSON.parse(req);

    const response = await getQuotesList(params);

    const { data: dataResponse } = response.payload;
    const selectedRequest = dataResponse.find(
      (el: any) => el.nroOperacion === data.nroOperacion
    );
    const { mejoraParcial } = selectedRequest.producto.find(
      (product: any) => product.id == selectedModality.id
    );
    if (selectedRequest.modalidadRecalculada) {
      setRecalculatedData(selectedRequest.modalidadRecalculada);
    }
    setImprovedData(mejoraParcial);
    setLoadingState(false);
  };

  const validateInitialValue = (monto: any, initialValue: any) => {
    const montoNumerico = parseFloat(monto);
    const limite = initialValue * 1.2;

    if (isNaN(montoNumerico)) {
    } else if (montoNumerico > limite) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  };

  const handleValidateUser = (state: boolean) => {
    setShowWarningUserValidation(!state);
  };

  const submitBeneficiary = async (data: any) => {
    setLoadingState(true);
    try {
      await updateBeneficiary(data);
      handleClose();
      handleSucessImprovements();
      setLoadingState(false);
    } catch (error) {
      console.error(error);
    }
  };

  const submitAssured = async (data: any) => {
    setLoadingState(true);
    try {
      await updateAssured(data);
      handleClose();
      handleSucessImprovements();
      setLoadingState(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDateChange = (initDate: any, typeDate: any) => {
    setErrorDate(null);
    if (typeDate === "fechaRecal1") {
      setSelectDate1(initDate);
    }
  };

  useEffect(() => {
    if (selectedModality && selectedModality.mejoraParcial) {
      setImprovedData(selectedModality.mejoraParcial);
    }
  }, [selectedModality]);

  return {
    isOpen,
    loadingState,
    recalculatedData,
    improvedData,
    typeMoneyDescriptionList,
    showWarning,
    showWarningUserValidation,
    errorDate,
    dataRecalculate,
    selectDate1,
    conditionInvalidateList,
    modalAsideState,
    handleOpen,
    handleClose,
    onSubmitImprovement,
    onSubmitReCalculate,
    saveRecalculated,
    setAlert,
    saveImprovement,
    getQuotes,
    validateInitialValue,
    handleValidateUser,
    submitBeneficiary,
    submitAssured,
    handleDateChange,
  };
};
